import React, { FC } from 'react';

import { fc } from 'i18n';
import { Controls } from './controls';
import { TableFooter } from './footer';
import { StickyTable } from 'components/organisms/sticky-table';
import { useClientsNotifications } from 'hooks/tep/clients-notifications/useClientsNotifications';

import styles from './styles.module.css';

export const TepClientsNotifications: FC = () => {
  const { controlProps, tableProps, footerProps } = useClientsNotifications();

  return (
    <div className={styles.wrapper} style={{ height: `${window.innerHeight - 70}px` }}>
      <div className={styles.card}>
        <div className={styles.header}>{fc('Client Notifications')}</div>
        <Controls {...controlProps} />
        <StickyTable {...tableProps} />
        {!!tableProps.data?.length && <TableFooter {...footerProps} />}
      </div>
    </div>
  );
};
